export const placeholderTestId = 'placeholder-test-id';

// Typewriter animation timing constants
export const TYPEWRITER_TYPE_DELAY = 50; // Delay between typing each character
export const TYPEWRITER_PAUSE_BEFORE_ERASE = 2000; // Pause before starting to erase text
export const TYPEWRITER_ERASE_DELAY = 40; // Delay between erasing each character
export const TYPEWRITER_CYCLE_DELAY = 500; // Delay before starting next cycle
export const TYPEWRITER_TYPED_AND_DELETED_DELAY = 1500; // Delay before starting animation after user typed and deleted

export const nodeTypesWithLongPlaceholderText = ['expand', 'panel'];
export const nodeTypesWithShortPlaceholderText = ['tableCell', 'tableHeader'];
export const nodeTypesWithSyncBlockPlaceholderText = ['bodiedSyncBlock'];
